// extracted by mini-css-extract-plugin
export default {"title":"PaymentChangeDisabled-module__title--glXeX","text":"PaymentChangeDisabled-module__text--zMSyl","actions":"PaymentChangeDisabled-module__actions--Ed2VG"};